import React from 'react';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import BulkGradingWrapper from '@/components/shared/Grading/Navigation/BulkGrading';
import useQuestionScoresData from './useQuestionScoresData';

const BulkGradingButton = () => {
  const assignment = useGradingStore(state => state.assignment);
  const { isFetching, rows } = useQuestionScoresData();

  if (rows.length === 0) return null;

  return <BulkGradingWrapper assignment={assignment} disabled={isFetching} scoresData={rows} />;
};

export default BulkGradingButton;
